module.exports = __webpack_public_path__ + "media/images/amenities_icons/chromecast-ff773bf6e6a56954a9157cba28ac7b01.svg";